<template>
    <!--<div class="synchronous-scrolling">-->
    <!--&lt;!&ndash;<div class="content-area-top" ref="top" :style="{'grid-template-columns':templateColumns}">&ndash;&gt;-->
    <!--&lt;!&ndash;<slot name="top"></slot>&ndash;&gt;-->
    <!--&lt;!&ndash;</div>&ndash;&gt;-->
    <!--&lt;!&ndash;<div class="flex-1 content-area" ref="content"  @scroll="scrollEvent" :style="{'grid-template-columns':templateColumns}">&ndash;&gt;-->
    <!--&lt;!&ndash;<slot></slot>&ndash;&gt;-->
    <!--&lt;!&ndash;</div>&ndash;&gt;-->
    <!--</div>-->
    <div class="synchronous-scrolling flex-n">
        <div class="left">
            <div class="content-area-top"></div>
            <div class="content-area" ref="left">
                <slot name="left"></slot>
            </div>
<!--            <div style="background: #F5F5F5;padding: 0;height: 17px"></div>-->
        </div>
        <div class="right">
            <div class="content-area-top" ref="top" :style="{'grid-template-columns':templateColumns}">
                <slot name="top"></slot>
            </div>
            <div class="flex-1 content-area" ref="content" @scroll="scrollEvent"
                 :style="{'grid-template-columns':templateColumns}">
                <div v-for="i in num" :style="{'grid-row': Math.ceil(i/(columns||1))+' / span 1','grid-column':(i%columns==0?columns:i%columns)+' /span 1','z-index': 0}">
                </div>
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "synchronous-scrolling",
        props: {
            columns:{
              type:Number,
                default:1
            },
            templateColumns: {
                type: String,
                default: 'repeat(4,minmax(100px,1fr))'
            },
            num:{
                type:Number,
                default:1000
            }
        },
        mounted() {

        },
        methods: {
            scrollEvent(e) {
                // console.log(e)
                // console.log(e.target.scrollLeft, this.$refs.top)
                this.$nextTick(() => {
                    if (this.$refs.top)
                        this.$refs.top.scrollLeft = e.target.scrollLeft
                    if (this.$refs.left)
                        this.$refs.left.scrollTop = e.target.scrollTop
                })

                // document.getElementById('top').scrollLeft=e.target.scrollLeft
            }
        }
    }
</script>

<style scoped lang="scss">
    .synchronous-scrolling {
        border: 1px solid #f1f1f1;
        .left {
            width: 90px;
            min-width: 90px;
            display: flex;
            flex-direction: column;
            height: 100%;
            overflow-x: scroll;
            .content-area-top {
                height: 30px;
                max-height: 30px;
                padding: 0;
                background: #d2e6fe;
            }

            > div:not(:last-child) {
                //border-bottom: 1px solid #f1f1f1;
            }
            .content-area {
                flex: 1;
                overflow: hidden;
                > div {
                    padding: 0px 10px;
                    text-align: center;
                    height: 23px;
                    max-height: 23px;
                    line-height: 23px;
                }
                >div{
                    border-bottom: 1px solid #f1f1f1;
                }
            }
        }
        .right {
            flex: 1;
            border-left: 1px solid #f1f1f1;
            overflow: hidden;
            .content-area-top {
                height: 30px;
              max-height: 30px;
                text-align: center;
                display: grid;
                overflow-y: scroll;
                overflow-x: hidden;
                > div {
                    display: flex;
                    align-items: center;
                    border-right: 1px solid #f1f1f1;
                    font-size: 14px;
                    text-align: center;
                    justify-content: center;
                    font-weight: bold;
                    background: #d2e6fe;
                    color: #333;
                }
            }

            .content-area {
                overflow: scroll;
                display: grid;
                grid-template-rows: repeat(auto-fill,24px);
                /*background: #5a9ea2;*/
                height: calc(100% - 30px);
                > div {
                    display: flex;
                    align-items: center;
                    height: 23px;
                    border-right: 1px solid #f1f1f1;
                    border-bottom: 1px solid #f1f1f1;
                }
              > div:not(:last-child) {
                border-bottom: 1px solid #f1f1f1;
              }
            }
        }
    }


</style>
